import './Feedback.scss';

import {
  Button,
  IconButton,
  Icons,
  InputField,
  Modal,
  ModalBody,
} from 'plume-ui';
import React, { FunctionComponent, memo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTrackEvent } from '../../features/trackingAnalytics/hooks/useTrackEvent';
import { MixPanelEvents } from '../../mixPanelEvents';

type FeedbackProps = {
  screen?: string | '';
};

const Feedback: FunctionComponent<FeedbackProps> = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showSubmittedMessage, setShowSubmittedMessage] = useState(false);
  const [rating, setRating] = useState('');
  const [message, setMessage] = useState('');
  const [selected, setSelected] = useState({
    thumbsUp: false,
    thumbsDown: false,
  });

  const { t } = useTranslation();
  const trackEvent = useTrackEvent();

  const handleIconButtonClick = (rating: string) => {
    setRating(rating);
    setSelected({
      thumbsUp: rating === 'thumbsUp',
      thumbsDown: rating === 'thumbsDown',
    });
  };

  const handleSubmit = () => {
    setShowSubmittedMessage(true);

    trackEvent({
      eventName: MixPanelEvents.FEEDBACK,
      additionalContent: {
        RATING: rating,
        MESSAGE: message,
        SCREEN: props.screen || '',
      },
    });

    setTimeout(() => setShowSubmittedMessage(false), 5000);
    setIsModalOpen(false);
    setSelected({ thumbsUp: false, thumbsDown: false });
  };

  return (
    <>
      {showSubmittedMessage ? (
        <div className="Feedback Feedback__Received">
          {t('feedback.received')}
          <Icons.CheckIcon width={18} />
        </div>
      ) : (
        <Button
          onClick={() => setIsModalOpen(true)}
          classes={(current) => ({
            ...current,
            root: `${current.root} Feedback Button`,
          })}
        >
          {t('feedback.howDidWeDo')}
          <Icons.ArrowRightIcon width={14} />
        </Button>
      )}

      <div className="Feedback__Modal">
        <Modal
          isOpen={isModalOpen}
          onRequestClose={() => {
            setIsModalOpen(false);
            setSelected({ thumbsUp: false, thumbsDown: false });
          }}
          className="Feedback__Modal Feedback Modal"
          style={{
            content: {
              position: 'fixed',
              right: '20px',
              bottom: '20px',
              transform: 'none',
            },
          }}
        >
          <ModalBody>
            <div className="Feedback__Modal__IconsWrapper">
              <IconButton
                icon={<Icons.LikeIcon />}
                onClick={(event) => {
                  event.stopPropagation();
                  handleIconButtonClick('thumbsUp');
                }}
                selected={selected.thumbsUp}
              />
              <IconButton
                icon={<Icons.DislikeIcon />}
                onClick={(event) => {
                  event.stopPropagation();
                  handleIconButtonClick('thumbsDown');
                }}
                selected={selected.thumbsDown}
              />
            </div>
            <InputField
              placeholder={t('feedback.addComment')}
              onChange={(e) => setMessage(e.target.value)}
            />
            <Button
              onClick={handleSubmit}
              classes={(current) => ({
                root: `${current.root} Feedback__Modal__SubmitButton`,
                container: `${current.container}`,
                loader: `${current.loader}`,
              })}
              styleVariant="superprimary"
            >
              {t('submit')}
            </Button>
          </ModalBody>
        </Modal>
      </div>
    </>
  );
};

export default memo(Feedback);
